export default __webpack_public_path__ + "static/makula-lutein-zeaxanthin-kaufen-2598246a2ae272346605f823125706d4.jpg";